import {Log} from '@aboutyou/mlm';
import {useCanGoBack} from '@aboutyou/router';
import {useEffect, useRef} from 'react';

export const useLogHydrationFailed = ({context}: {context: string}) => {
  const canGoBack = useCanGoBack();
  const logged = useRef(false);

  useEffect(() => {
    if (logged.current) {
      return;
    }
    if (!canGoBack) {
      Log.error('@aboutyou/logic-components', 'HydrationFailedSkeleton', {
        context,
      });
      logged.current = true;
    }
  }, [canGoBack, context]);

  return null;
};
